import { createContext, useContext, useState } from "react";
import { baseUrl } from "../config/config";
import io from "socket.io-client";

const CreateContentSetting = createContext();

const noopSocket = {
  connected: false,
  on: () => {},
  off: () => {},
  emit: () => {},
  disconnect: () => {},
  once: () => {},
};

let socket = noopSocket;

export const useContentSetting = () => useContext(CreateContentSetting);
export function ContentSetting({ children }) {
  const [userInfo, setUserInfo] = useState({});
  const [unreadMessageCount, setUnreadMessageCount] = useState(0);
  const [initSettings, setInitSettings] = useState({});
  const [reportsList, setReportsList] = useState([]);
  const [startedMeeting, setStartedMeeting] = useState({});

  const START_SOCKET_FORCEFULLY = (user_id) => {
    socket = io(baseUrl + `?user_id=${user_id}&user_type=admin`, {
      withCredentials: true,
      transports: ["websocket"],
    });
  };

  const STOP_SOCKET_FORCEFULLY = () => {
    socket.disconnect();
  };

  const collection = {
    userInfo,
    socket,
    unreadMessageCount,
    startedMeeting,
    reportsList,
    setUserInfo,
    setReportsList,
    setUnreadMessageCount,
    setStartedMeeting,
    START_SOCKET_FORCEFULLY,
    STOP_SOCKET_FORCEFULLY,
    setInitSettings,
    initSettings,
  };

  return (
    <CreateContentSetting.Provider value={collection}>
      {children}
    </CreateContentSetting.Provider>
  );
}
